export const gameIsPaused = (): boolean =>
  document.body.classList.contains("paused");
